// Declarative milestone catalog — no React imports, testable in isolation.
// condicion receives the stats object from getMyFullStats().

export const MILESTONES = [
  {
    id: 'primer_pae_rapido',
    titulo: 'Diste el primer paso',
    mensaje: 'Completaste tu primer PAE Rápido. Eso ya es construir hábito clínico.',
    icono: 'sparkles',
    condicion: s => s.paeRapidoCount >= 1,
  },
  {
    id: 'primer_pae_detallado',
    titulo: 'Profundizaste en el proceso',
    mensaje: 'Completaste un PAE Detallado. La valoración completa transforma el cuidado.',
    icono: 'pen-line',
    condicion: s => s.paeDetalladoCount >= 1,
  },
  {
    id: 'cinco_paes',
    titulo: 'Vas construyendo criterio',
    mensaje: 'Cinco PAEs completados. Cada caso entrena tu razonamiento clínico.',
    icono: 'trending-up',
    condicion: s => s.totalPaes >= 5,
  },
  {
    id: 'diez_paes',
    titulo: 'Tu razonamiento está madurando',
    mensaje: 'Diez PAEs. Ya tienes una base sólida de razonamiento clínico.',
    icono: 'award',
    condicion: s => s.totalPaes >= 10,
  },
  {
    id: 'primera_bitacora',
    titulo: 'Te diste tiempo de pensar',
    mensaje: 'Escribiste tu primera entrada en la bitácora. Reflexionar es parte de cuidar bien.',
    icono: 'book-open',
    condicion: s => s.bitacoraCount >= 1,
  },
  {
    id: 'siete_reflexiones',
    titulo: 'Reflexionar es parte de cuidar',
    mensaje: 'Siete reflexiones escritas. El hábito de reflexión distingue la práctica experta.',
    icono: 'book-open',
    condicion: s => s.bitacoraCount >= 7,
  },
  {
    id: 'sistema_respiratorio',
    titulo: 'Exploraste sistema respiratorio',
    mensaje: 'Trabajaste un diagnóstico de sistema respiratorio. Los pulmones son el punto de entrada.',
    icono: 'wind',
    condicion: s => s.systemsWorked.has('respiratorio'),
  },
  {
    id: 'uso_revisa',
    titulo: 'Buscaste retroalimentación',
    mensaje: 'Usaste Revisa para reflexionar sobre tu práctica. Eso es aprendizaje activo.',
    icono: 'message-square',
    condicion: s => s.modulesUsed.has('revisa'),
  },
  {
    id: 'uso_prepara_internado',
    titulo: 'Te preparaste antes de empezar',
    mensaje: 'Exploraste Prepara tu Internado. Llegar preparado siempre marca la diferencia.',
    icono: 'book-open',
    condicion: s => s.modulesUsed.has('prepara_internado'),
  },
  {
    id: 'uso_prepara_turno',
    titulo: 'Llegaste listo a tu turno',
    mensaje: 'Usaste Prepara tu turno. La preparación previa es parte del cuidado.',
    icono: 'clock',
    condicion: s => s.modulesUsed.has('mi_turno_prepara'),
  },
  {
    id: 'sistemas_variados',
    titulo: 'Pensás de forma integral',
    mensaje: 'Trabajaste diagnósticos de tres sistemas distintos. El cuidado integral se construye así.',
    icono: 'target',
    condicion: s => s.systemsWorked.size >= 3,
  },
  {
    id: 'un_mes_activo',
    titulo: 'Constancia construye criterio',
    mensaje: 'Un mes de actividad sostenida. La constancia es lo que separa el aprendizaje del estudio.',
    icono: 'calendar',
    condicion: s => s.activeDaysCount >= 20,
  },
];

// Returns milestones already unlocked by the user.
export function evaluateMilestones(stats) {
  if (!stats) return [];
  return MILESTONES.filter(m => {
    try { return m.condicion(stats); }
    catch { return false; }
  });
}

// Returns the next 2 locked milestones as soft hints (no spoilers).
export function getNextHints(stats, count = 2) {
  if (!stats) return [];
  const unlocked = new Set(evaluateMilestones(stats).map(m => m.id));
  return MILESTONES
    .filter(m => !unlocked.has(m.id))
    .slice(0, count);
}
